// Home.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MenuHeader from "./MenuHeader";
import { useTranslation } from 'react-i18next';
import useAuth from "../hooks/useAuth";
import homeIcon from '../assets/images/home-png.png';


function Home() {
  const [selection, setSelection] = useState("");
  const navigate = useNavigate();
  const { t } = useTranslation('auth');
  const { auth } = useAuth();

  // useEffect(() => {
  //   if (!localStorage.getItem('i18nextLng')) {
  //     i18n.changeLanguage('fr');
  //   }
  // }, [i18n]);



  useEffect(() => {
    console.log("authhh", auth);
    if (sessionStorage.getItem('state')) {
      sessionStorage.removeItem('state');
    }
    if (sessionStorage.getItem('chooseServiceState')) {
      sessionStorage.removeItem('chooseServiceState');
    }

    if (sessionStorage.getItem('redirectAfterLogin')) {
      sessionStorage.removeItem('redirectAfterLogin');
    }

    if (sessionStorage.getItem('address')) {
      sessionStorage.removeItem('address');
    }

    if (sessionStorage.getItem('previousPath')) {
      sessionStorage.removeItem('previousPath');
    }

    if (sessionStorage.getItem('paymentState')) {
      sessionStorage.removeItem('paymentState');
    }

    if (sessionStorage.getItem('hotelChooseServiceState')) {
      sessionStorage.removeItem('hotelChooseServiceState');
    }

    if (sessionStorage.getItem('newBooking')) {
      sessionStorage.removeItem('newBooking');
    }

  }, []);

  const handleSelectionChange = (event) => {
    const name = event.target.name;
    if (selection === name) {
      setSelection("");
    } else {
      setSelection(name);
    }
  }

  const handleSelection = (event) => {
    switch (event.target.name) {
      case 'soin':
        navigate("/choose-location");
        break;
      case 'hotel':
        navigate("/hotels");
        break;
      case 'flyprofav':
        navigate("/location-pro");
        break;
      default:
        navigate("/choose-location");
        break;
    }

  }
  const handleGift = (event) => {
    navigate("/gifts");

  }
  return (
    <>
      <MenuHeader />
      <div className="page-home">
        <div className="container home flex-column gap-50 align-center">
          <img src="assets/images/logo-alt.svg" alt="Flyspa Logo"></img>
          <h1>{auth?.user?.civility == "MS" ? t('home.readyForMassage2') : t('home.readyForMassage')}</h1>
          <div className="card">
            <div className="card-header card-selection">
              <button type="button" name="service" onClick={handleSelectionChange} className={selection === "service" ? "btn-primary active" : "btn-primary"}>{t('home.service')} {selection === "service" && (<img src="assets/images/arrow_down.svg" alt="icon" />)}</button>
              <button type="button" name="flypro" onClick={handleSelectionChange} className={selection === "flypro" ? "btn-primary active" : "btn-primary"}>{t('home.flypro')} {selection === "flypro" && (<img src="assets/images/arrow_down.svg" alt="icon" />)}</button>
            </div>
            <div className={`card-body ${selection === "" ? "empty" : ""}`}>
              {selection === "service" && (
                <>
                  <button type="button" name="soin" onClick={handleSelection} className="btn-primary active"><img src={homeIcon} alt="icon" style={{ width: '24px', height: '24px' }} />{t('home.chooseCare')} </button>
                  <button type="button" name="hotel" onClick={handleSelection} className="btn-primary active"><img src="assets/images/icon-hotel.svg" alt="icon" />{t('home.choosePartnerHotel')} </button>
                </>
              )}
              {selection === "flypro" && (
                <>
                  <button type="button" name="flyprofav" onClick={handleSelection} className="btn-primary active"><img src="assets/images/icon-pro.svg" alt="icon" />{t('home.chooseFlypro')} </button>
                </>
              )}
            </div>
          </div>
          <button type="button" name="flypro" onClick={handleGift} className="btn-secondary active"><img src="assets/images/icon-gift.svg" alt="cadeau" />{t('home.giftButton')}</button>
        </div>
      </div>
    </>
  );
}

export default Home;
